import { Pipe, PipeTransform } from '@angular/core';
import { AirportI18nJoinByAirportCode } from '@common/master/airport-i18n-join-by-airport-code';
import { LOAD_MASTERS } from '@common/master/master';
import { AswMasterService } from '@lib/services';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

/**
 * 空港コードから空港名に変換するPIPE
 * このパイプは、前提としてASWDB(空港テーブル)がロードされている必要があります。
 *
 * ASWDB(空港テーブル)から取得できなかった場合の指定があれば、オプショナルに指定できます。
 */
@Pipe({
  name: 'airportName',
  pure: false,
})
export class AirportNamePipe implements PipeTransform {
  /** 空港マスタ */
  private airportTable$: Observable<AirportI18nJoinByAirportCode>;
  private airportTable!: AirportI18nJoinByAirportCode;

  constructor(masterService: AswMasterService) {
    this.airportTable$ = masterService.getAswMasterByKey$(LOAD_MASTERS.AIRPORT_I18NJOIN_BY_AIRPORT_CODE.key);
    this.airportTable$
      .pipe(
        filter((data) => !!data),
        take(1)
      )
      .subscribe((airportTable) => {
        this.airportTable = airportTable;
      });
  }

  /**
   * 空港コードから空港名に変換するPIPE
   * StaticMsgの変換を含みます(多言語化対応を含みます)
   *
   * 空港コードが指定されていない場合 surrogateNameを返しますが、surrogateNameも
   * 指定省略された場合は空文字列を返します。
   * @param {string} code 空港コード
   * @param {string} surrogateName ASWDBから名称が取得できない場合に表示するべき名称(省略可)
   * @returns {string} 空港名(多言語対応を含む)
   */
  transform(code: string | undefined, surrogateName: string = ''): string {
    if (!code || !this.airportTable) {
      return surrogateName;
    }
    const airportTypes = this.airportTable[code];
    if (airportTypes && airportTypes.length > 0 && airportTypes[0].airport_name) {
      return airportTypes[0].airport_name;
    } else {
      return surrogateName;
    }
  }
}
